import { Stack } from '@mui/material';
import logoGalenaEdupass from '@/assets/images/logos/logo-nav-galena.svg';
import { useNavigate } from '@/hooks/use-navigation';
import { useProfileShow } from '@/data/account/profile';

export const MainLogo = () => {
  const navigate = useNavigate();
  const { profile } = useProfileShow();

  const companyLogoUrl = profile?.company?.logo_url;
  const companyLogoAlt = profile?.company?.name;

  return (
    <Stack
      component="a"
      href="/"
      direction="row"
      alignItems="center"
      gap={1}
      onClick={(e) => {
        e.preventDefault();
        navigate('/');
      }}
    >
      <img src={logoGalenaEdupass} alt="Galena" />
      {companyLogoUrl && (
        <>
          <Stack
            sx={({ palette }) => ({
              width: '1px',
              height: 24,
              backgroundColor: palette.neutral[200],
            })}
          />
          <img
            src={companyLogoUrl}
            alt={companyLogoAlt}
            style={{ maxWidth: 130, height: 32, objectFit: 'contain' }}
          />
        </>
      )}
    </Stack>
  );
};
